import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../admin-app/services/auth.service';
import {TokenStorage} from '../../core/token.storage';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CheckRoleService } from '../../common/services/check-role.service';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  isAdmin = false;

  constructor(private router: Router, private token: TokenStorage,  private toastr: ToastrService,  private checkRole: CheckRoleService) { }
    
    ngOnInit(){
      if (this.checkRole.isAdmin() == true ){
        this.isAdmin = true;
      }
    }

    loginOut(): void {
        // Get current url.
        let url =  window.location.href;
        let pathArray = url.split( '/' );
        let findingItem = pathArray[3];
        
        //console.log(findingItem);
        this.token.signOut()
        if (findingItem == "admin"){
          this.router.navigate(['admin/login']);
        }
        else{
          this.router.navigate(['login']);

        }
       
        this.showSuccess();
  }

  // For Toatr. 
  showSuccess() {
    this.toastr.success('Déconnexion éffectuée avec succès!', 'Déconnexion!');
  }


}



// WEBPACK FOOTER //
// ./src/app/common/navbar/navbar.component.ts